/**
 * @generated SignedSource<<6e2c57b0737019d1da287b0da93a3f32>>
 * @relayHash 3b9214d32d7c898344994eccc6859225
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b9214d32d7c898344994eccc6859225

import { ConcreteRequest } from 'relay-runtime';
export type useUnknownCareProviderQuery$variables = {
  skip: boolean;
};
export type useUnknownCareProviderQuery$data = {
  readonly ch_unknownCareProvider?: {
    readonly id: string;
  } | null;
};
export type useUnknownCareProviderQuery = {
  response: useUnknownCareProviderQuery$data;
  variables: useUnknownCareProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareProvider",
        "kind": "LinkedField",
        "name": "ch_unknownCareProvider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUnknownCareProviderQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUnknownCareProviderQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "3b9214d32d7c898344994eccc6859225",
    "metadata": {},
    "name": "useUnknownCareProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a53e4b32591ffe4bd6e9290b471011b7";

export default node;
